export default __webpack_public_path__ + "static/media/B1.5cab7593.mp3";